<template>
  <icon-component v-bind="$props">
    <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M66.283 21.28v9.397H27.69V21.28h38.592Zm4.458-7.413h-47.51a2.973 2.973 0 0 0-2.964 2.965v18.293a2.966 2.966 0 0 0 2.965 2.966h47.51a2.966 2.966 0 0 0 2.965-2.966V16.832a2.966 2.966 0 0 0-2.966-2.965ZM70.741 44.065h-47.51a2.966 2.966 0 0 0-2.964 2.965v29.579a2.966 2.966 0 0 0 2.965 2.965H53.76v-7.413H27.68V51.489h38.603v8.17h7.413V47.041a2.959 2.959 0 0 0-2.965-2.966l.01-.01Z"
        fill="currentColor"
      />
      <path d="M75.2 65.398H59.51v15.69H75.2v-15.69Z" fill="currentColor" />
    </svg>
  </icon-component>
</template>

<script>
  import IconComponent from './IconComponent.vue';

  export default {
    components: {
      IconComponent,
    },
    extends: IconComponent,
  };
</script>
